import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import NotFound from "./pages/NotFound";
import DigitalTransformation from "./pages/DigitalTransformation";
import AIAutomation from "./pages/AIAutomation";
import Blog from "./pages/Blog";
import AfricanBusiness from "./pages/AfricanBusiness";
import CompetitorAnalysis from "./pages/CompetitorAnalysis";
import GlobalExpansion from "./pages/GlobalExpansion";
import QuantumBoxGuide from "./pages/QuantumBoxGuide";
import Assessment from "./pages/Assessment";
import RPAAssessment from "./pages/RPAAssessment";
import AgenticAI from "./pages/AgenticAI";
import RAGSolutions from "./pages/RAGSolutions";
import AIChatbots from "./pages/AIChatbots";
import Academy from "./pages/Academy";
import BadgeVerification from "./pages/BadgeVerification";
import TrainingAssessment from "./pages/TrainingAssessment";
import SovereignScout from "./pages/SovereignScout";
import MineralExplorationAIGuide from "./pages/sovereign-scout/MineralExplorationAIGuide";
import LithiumExplorationAI from "./pages/sovereign-scout/LithiumExplorationAI";
import AfricaMineralExploration from "./pages/sovereign-scout/AfricaMineralExploration";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <LanguageProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/digital-transformation" element={<DigitalTransformation />} />
            <Route path="/ai-automation" element={<AIAutomation />} />
          <Route path="/quantumbox-guide" element={<QuantumBoxGuide />} />
          <Route path="/assessment" element={<Assessment />} />
            <Route path="/rpa-assessment" element={<RPAAssessment />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/african-business" element={<AfricanBusiness />} />
            <Route path="/competitive-analysis" element={<CompetitorAnalysis />} />
            <Route path="/global-expansion" element={<GlobalExpansion />} />
            <Route path="/agentic-ai" element={<AgenticAI />} />
            <Route path="/rag-solutions" element={<RAGSolutions />} />
            <Route path="/ai-chatbots" element={<AIChatbots />} />
            <Route path="/academy" element={<Academy />} />
            <Route path="/badge/:verificationCode" element={<BadgeVerification />} />
            <Route path="/training-assessment" element={<TrainingAssessment />} />
            <Route path="/sovereign-scout" element={<SovereignScout />} />
            <Route path="/sovereign-scout/mineral-exploration-ai-guide" element={<MineralExplorationAIGuide />} />
            <Route path="/sovereign-scout/lithium-exploration-ai" element={<LithiumExplorationAI />} />
            <Route path="/sovereign-scout/africa" element={<AfricaMineralExploration />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </LanguageProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
